import BookListSnp from './SnpBookList';

export default BookListSnp;
